module.exports = __webpack_public_path__ + "screenshot.4fc9cc4eab25df7285ff9b958c95e5f1.png";